module.exports = __webpack_public_path__ + "img/2-12.b3d52b17.svg";